// FNV-1a 32-bit over UTF-16 code units, suffixed with the length so two
// paragraphs that happen to collide on the hash still differ. Cheap enough to
// run over every textblock on every transaction.
export function hashText(text: string): string {
  let h = 0x811c9dc5;
  for (let i = 0; i < text.length; i++) {
    h ^= text.charCodeAt(i);
    h = Math.imul(h, 0x01000193) >>> 0;
  }
  return `${h.toString(16)}-${text.length}`;
}
